import { User } from '@marketing-milk/interfaces'

/** Collapsed, ten identical glyphs in one column read as a list you count
 *  rather than one you recognise. The rail rules between groups. */
export type NavGroup = 'home' | 'plan' | 'run' | 'rare'

export interface NavLinkI {
  url: string
  icon: string
  label: string
  group: NavGroup
  visible?: boolean
  externalLink?: string
}

export function getNavLinks(busID: string | number = 0, user?: User): NavLinkI[] {
  const newAppBase = process.env.REACT_APP_NEW_APP_URL
  const newAppLink = newAppBase
    ? busID
      ? `${newAppBase}/${busID}/meta/marketing-funnel`
      : newAppBase
    : undefined

  return [
    {
      label: 'Analytics',
      icon: 'chart-line',
      url: 'marketing-milk',
      externalLink: newAppLink,
      visible: Boolean(newAppBase),
      group: 'home',
    },
    {
      label: 'Sprints',
      icon: 'calendar-alt',
      url: `${busID}/sprints`,
      group: 'plan',
    },
    {
      label: 'Sprint Packets',
      icon: 'presentation',
      url: `${busID}/sprint-packets`,
      group: 'plan',
    },
    {
      label: 'Campaigns',
      icon: 'megaphone',
      url: `${busID}/campaigns`,
      group: 'run',
    },
    {
      label: 'Audiences',
      icon: 'users',
      url: `${busID}/audiences`,
      group: 'run',
    },
    {
      label: 'Creatives',
      icon: 'images',
      url: `${busID}/creatives`,
      group: 'run',
    },
    {
      label: 'Lead Cards',
      icon: 'clipboard-list',
      url: `${busID}/lead-cards`,
      group: 'run',
    },
    {
      label: 'Local Competition',
      icon: 'radar',
      url: `${busID}/competition`,
      group: 'rare',
    },
    {
      label: 'AI Studio',
      icon: 'magic',
      url: `${busID}/ai-studio`,
      group: 'rare',
    },
  ]
}
